import React from "react";
import { observer, inject } from "mobx-react";
import styled from "styled-components";

import { Search, Revert } from "grommet-icons";
import Button from "app/components/Button";

const Icon = styled(Search)`
  width: 40px;
  height: 40px;
  @media (max-width: 600px) {
    width: 24px;
    height: 24px;
  }
`;

const Return = styled(Revert)`
  width: 48px;
  height: 48px;
  @media (max-width: 600px) {
    width: 24px;
    height: 24px;
  }
`;

function SearchButton({ AppState }) {
  const { isSearchResultsOpen: isOpen } = AppState;
  return (
    <Button
      title="Search"
      pad="small"
      justify="center"
      align="center"
      onClick={() => {
        AppState.toggleSearchResults();
      }}
    >
      {!isOpen && <Icon color="accent-1" />}
      {isOpen && <Return color="accent-1" />}
    </Button>
  );
}

export default inject("AppState")(observer(SearchButton));



// WEBPACK FOOTER //
// ./src/app/components/MainMenu/SearchButton.js